import React from "react";
import { useNavigate } from "react-router-dom";
import { Image } from "react-bootstrap";

import "./UserAvatar.scss";
import useAuth from "../../hooks/useAuth";
import { ROUTES } from "../../utils/constants";
import PersonIcon from "../icons/PersonIcon";
import Skeleton from "../Skeleton/Skeleton";

export default function UserAvatar() {
  const navigate = useNavigate();
  const { userProfile } = useAuth();
  const avatar = userProfile?.avatar?.url;

  return (
    <Skeleton isLoading={!userProfile} width={32} height={32}>
      <button
        className="px-0 rounded-avatar"
        onClick={() => navigate(ROUTES.ROOT.PROFILE)}
      >
        {avatar ? (
          <Image src={avatar} alt="avatar" />
        ) : (
          <PersonIcon fill="#f5f0ff" width="1.2em" />
        )}
      </button>
    </Skeleton>
  );
}
